import type { Routes } from '@angular/router';
import { composePath } from 'src/helpers/compose-path';
import { canActivateLang } from 'src/helpers/lang-guard';

import { confirmProfileGuard } from './guards/canDeactivateConfirmProfile.guard';
import { AuthComponent } from './auth/auth.component';
import { canActivateAuth } from './auth/auth.guard';
import { UserProfileComponent } from './user-profile/user-profile.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: composePath('/profile'),
    pathMatch: 'full',
  },
  {
    path: ':lang/profile',
    component: UserProfileComponent,
    canActivate: [canActivateLang, canActivateAuth],
  },
  {
    path: ':lang/profile/change-data',
    loadComponent: () =>
      import('./change-profile-data/change-profile-data.component').then((c) => c.ChangeProfileDataComponent),
    canActivate: [canActivateLang, canActivateAuth],
  },
  {
    path: ':lang/profile/change-password',
    loadComponent: () => import('./change-password/change-password.component').then((m) => m.ChangePasswordComponent),
    canActivate: [canActivateLang, canActivateAuth],
  },
  {
    path: ':lang/profile/confirm-data',
    loadComponent: () =>
      import('./confirm-user-profile/confirm-user-profile.component').then((m) => m.ConfirmUserProfileComponent),
    canActivate: [canActivateLang, canActivateAuth],
    canDeactivate: [confirmProfileGuard],
  },
  {
    path: ':lang/terms',
    loadComponent: () => import('./user-terms/user-terms.component').then((m) => m.UserTermsComponent),
    canActivate: [canActivateLang, canActivateAuth],
  },
  {
    path: ':lang/auth',
    component: AuthComponent,
  },
  {
    path: '**',
    redirectTo: composePath('/profile'),
  },
];
